module.exports = __webpack_public_path__ + "img/05.5b9129ac.png";